import { render, staticRenderFns } from "./pwd.vue?vue&type=template&id=5de327ce&scoped=true&"
import script from "./pwd.vue?vue&type=script&lang=js&"
export * from "./pwd.vue?vue&type=script&lang=js&"
import style0 from "./pwd.vue?vue&type=style&index=0&id=5de327ce&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de327ce",
  null
  
)

export default component.exports